import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { useField } from 'formik';

const SelectMultipleWrapper = ({ name, options, label, ...otherProps }) => {
    const [field, meta] = useField(name);

    const configSelect = {
        variant: 'standard',
        ...field,
        ...otherProps,
        fullWidth: true,
        multiple: true,
    };

    if (meta && meta.touched && meta.error) {
        configSelect.error = true;
    }

    return (
        <FormControl fullWidth error={meta && meta.touched && meta.error}>
            <InputLabel sx={{ml: -1.8}}>{label}</InputLabel>
            <Select {...configSelect} label={label}>
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
            {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}
        </FormControl>
    );
};

export default SelectMultipleWrapper;
